import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-page__container">
        <div className="auth-page__header">
          <h1 className="auth-page__brand">NOTCHED</h1>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>RESET PASSWORD</h2>

          {sent ? (
            <div>
              <p className="text-muted" style={{ marginBottom: '16px' }}>
                If an account exists with that email, we've sent a password reset link. Check your inbox.
              </p>
              <Link to="/login" className="btn btn--secondary btn--full">
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <p className="text-muted" style={{ fontSize: '13px', marginBottom: '16px' }}>
                Enter your email and we'll send you a link to reset your password.
              </p>

              {error && (
                <div className="alert alert--error">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form__group">
                  <label>Email</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@email.com" required />
                </div>
                <button type="submit" className="btn btn--primary btn--full" disabled={loading}>
                  {loading ? <span className="spinner" /> : 'SEND RESET LINK'}
                </button>
              </form>
            </>
          )}
        </div>

        <div className="auth-page__footer">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
